import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import GatsbyImage from 'gatsby-image'
import styled from 'styled-components'

const Img = styled.img``

const FluidImage = ({ image, withFallback = false, ...props }) => {
	const data = useStaticQuery(graphql`
		query {
			fallbackImage: file(relativePath: { eq: "fallback.svg" }) {
				publicURL
			}
		}
	`)

	if (!image) {
		return withFallback ? (
			<img src={data.fallbackImage.publicURL} alt={'Fallback'} {...props} />
		) : null
	}

	let imageObj = image
	if (image.node !== undefined) {
		imageObj = image.node
	}

	if (image && imageObj.imageFile) {
		return (
			<GatsbyImage
				fluid={imageObj.imageFile.childImageSharp.fluid}
				alt={imageObj.altText}
				{...props}
			/>
		)
	}

	return <img src={imageObj.sourceUrl} alt={imageObj.altText} {...props} />
}

export default FluidImage
